<template>
  <multi-select-filter
    :id="filterData.key + '-filter'"
    :label="filterData.label"
    :get-value="getOptions"
    :multiple="true"
    :current-set-value="selectedOptions"
    :update-method="updateValue"
    track-by="value"
    display-value="text"
  />
</template>

<script>
import MultiSelectFilter from "../MultiSelectFilter.vue";

export default {
  name: "ListFilter",
  data() {
    return {
      selectedOptions: [],
    };
  },
  props: {
    filterData: {
      type: Object,
      required: true,
    },
  },
  components: {
    MultiSelectFilter,
  },
  computed: {
    getOptions: function () {
      // @todo We should look at making the '- Any -' text into a variable that is stored elsewhere.
      const opts = [{ value: 0, text: "- Any -" }];
      const allowedVals = this.filterData.definition.settings.allowed_values;
      Object.keys(allowedVals).forEach((optKey) => {
        opts.push(allowedVals[optKey]);
      });
      return opts;
    },
  },
  methods: {
    updateValue: function (values) {
      const cleanValues = [];
      values.forEach((valueData) => {
        // If key is undefined use value instead.
        if (typeof valueData.key === "undefined") {
          cleanValues.push(valueData.value);
        } else {
          cleanValues.push(valueData.key);
        }
      });
      this.selectedOptions = values;
      // @todo Would it be better to have a prop used to pass in a function to call?
      this.$emit("update-filters", this.filterData.key, cleanValues);
      this.$emit("update-filter", {
        id: this.filterData.key,
        value: cleanValues,
      });
    },
  },
};
</script>
